<template>
  <div class="t-lk-services">
    <div class="t-lk-container">
      <div class="t-lk-services__container">
        <div v-if="isMobile" class="t-lk-services-nav js-nav">
          <div v-animation:bottom.delay class="t-lk-services-nav__container" :class="{ _fixed: fixedNav }" ref="nav">
            <div
              class="t-lk-services-nav__item js-nav-item"
              :class="{ _active: activeNavIndex === 0 }"
              @click="scrollToSection(0)"
              :data-id="0"
            >
              {{ $root.staticText.lk.servicesDocuments }}
            </div>
            <div
              class="t-lk-services-nav__item js-nav-item"
              :class="{ _active: activeNavIndex === index + 1 }"
              v-for="(item, index) in services"
              @click="scrollToSection(index + 1)"
              :data-id="index + 1"
            >
              {{ item.title }}
            </div>
          </div>
        </div>

        <div class="t-lk-services__wrap js-section js-section0" :data-id="0">
          <h1 v-animation:bottom.delay class="t-lk-title t-lk-title-link__title t-lk-container-mobile">
            {{ $root.staticText.lk.servicesDocuments }}
          </h1>
          <div class="t-lk-services-doc _top">
            <lk-services-item-cmp
              v-animation:bottom.delay
              v-for="(item, index) in documents.slice(0, 3)"
              :key="'services-item' + index"
              :item="item"
              :index="index"
              :is-dropdown-doc="true"
              class="t-lk-services-doc__item _top"
              :style="{ 'z-index': documents.length - index }"
            >
            </lk-services-item-cmp>
          </div>
        </div>
      </div>
      <div class="t-lk-services-doc _bottom">
        <lk-services-item-cmp
          v-animation:bottom.delay
          v-for="(item, index) in documents.slice(3, documents.length)"
          :key="'services-item' + index"
          :item="item"
          :index="index"
          :is-dropdown-doc="true"
          class="t-lk-services-doc__item _bottom"
          :style="{ 'z-index': documents.length - index - 2 }"
        >
        </lk-services-item-cmp>
        <lk-services-item-cmp
          v-animation:bottom.delay
          :item="{
            name: $root.staticText.lk.servicesAct,
            btn: $root.staticText.lk.servicesBtn,
          }"
          :is-act="true"
          class="t-lk-services-doc__item _bottom"
        >
        </lk-services-item-cmp>
      </div>
      <banner-native-cmp v-if="bannerDocuments" v-animation:bottom.delay :banner="bannerDocuments" class="t-lk-services__banner">
      </banner-native-cmp>

      <div
        v-if="services.length"
        class="js-section js-section1"
        :class="services[0].anchor ? 'js-' + services[0].anchor : ''"
        :data-id="1"
      >
        <lk-title-link-cmp
          v-animation:bottom.delay
          :title="services[0].title"
          :link="services[0].link"
          :name="$root.staticText.lk.servicesAll"
          class="t-lk-services-block__title"
        ></lk-title-link-cmp>
        <div class="t-lk-main__container">
          <div v-if="bannerServices" class="t-lk-main__left">
            <banner-native-cmp v-animation:bottom.delay :banner="bannerServices" :is-vertical="!isMobile"> </banner-native-cmp>
          </div>
          <div class="t-lk-main__right">
            <div class="t-lk-services-block__container _1 _0" :class="{ _odd: services[0].items.length % 2 === 1 }">
              <lk-services-item-cmp
                v-animation:bottom.delay
                v-for="(item, index) in services[0].items"
                :key="'services-item' + index"
                :item="item"
                :is-request="true"
                :options-request="optionsRequest"
                class="t-lk-services-block__item"
              >
              </lk-services-item-cmp>
            </div>
          </div>
        </div>
      </div>

      <template v-if="services.length > 1">
        <div
          v-for="(item, index) in services.slice(1, services.length)"
          class="t-lk-services-block js-section"
          :class="['js-section' + (index + 2), item.anchor ? 'js-' + item.anchor : '']"
          :data-id="index + 2"
        >
          <lk-title-link-cmp
            v-animation:bottom.delay
            :title="item.title"
            :link="item.link"
            :name="$root.staticText.lk.servicesAll"
          ></lk-title-link-cmp>
          <div
            class="t-lk-services-block__container"
            :class="{ _1: index % 2 === 1, _2: index % 2 === 0, _odd: item.items.length % 2 === 1 }"
          >
            <lk-services-item-cmp
              v-animation:bottom.delay
              v-for="(item, index) in item.items"
              :key="'services-item' + index"
              :item="item"
              :is-request="true"
              :options-request="optionsRequest"
              class="t-lk-services-block__item"
            >
            </lk-services-item-cmp>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import titleLink from '@components/lk/lk-title-link/lk-title-link.vue'
import servicesItem from '@components/lk/lk-services-item/lk-services-item.vue'
import bannerNative from '@components/lk/banner-native/banner-native.vue'
import { mapState } from 'vuex'
import { observeNewAnimateBlocks } from '@shared/utils/animate/scroll.animate'
import { TRANSITION_DURATIONS } from '@shared/const/animation.const'

export default {
  name: 'lk-services',
  data() {
    return {
      optionsRequest: [],
      documents: [],
      bannerDocuments: null,
      bannerServices: null,
      services: [],

      activeNavIndex: 0,
      fixedNav: false,
    }
  },
  components: {
    'lk-title-link-cmp': titleLink,
    'lk-services-item-cmp': servicesItem,
    'banner-native-cmp': bannerNative,
  },
  computed: {
    ...mapState('mobile', ['isMobile', 'isTablet']),
  },
  methods: {
    setData(data) {
      this.optionsRequest = data.optionsRequest
      this.documents = data.documents
      this.bannerDocuments = data.bannerDocuments
      this.bannerServices = data.bannerServices
      this.services = data.services

      this.$nextTick(() => {
        observeNewAnimateBlocks({ initialDelay: TRANSITION_DURATIONS.PAGE_TRANSFORM })
      })
    },
    scrollToSection(index) {
      this.activeNavIndex = index
      this.scrollToBlock('.js-section' + index)
    },
    scrollToBlock(selector) {
      let elem = document.querySelector(selector)
      if (elem) {
        let animationOffset = elem.getAttribute('data-animate') === 'false' ? 50 : 0
        let top =
          elem.getBoundingClientRect().top + window.pageYOffset - document.querySelector('header').clientHeight - animationOffset - 64
        window.scrollTo({
          top: top,
          behavior: 'smooth',
        })
      }
    },
    isScrolledIntoView(container) {
      if (container) {
        const offset = 128
        const elementPosition = {
            top: window.pageYOffset + container.getBoundingClientRect().top,
            bottom: window.pageYOffset + container.getBoundingClientRect().bottom,
          },
          windowPosition = {
            top: window.pageYOffset,
            bottom: window.pageYOffset + document.documentElement.clientHeight - offset,
          }
        return elementPosition.bottom > windowPosition.bottom && elementPosition.top < windowPosition.bottom
      }
    },
    scrollLeft(id) {
      let offset = 0
      document.querySelectorAll('.js-nav-item').forEach((item, index) => {
        if (index < id) {
          offset = offset + item.clientWidth + 8
        }
      })

      this.$refs.nav.scrollTo({
        left: offset,
        behavior: 'smooth',
      })
    },
    scrollPage() {
      let topNav = document.querySelector('.js-nav').getBoundingClientRect().top
      this.fixedNav = topNav <= 64 + 8

      document.querySelectorAll('.js-section').forEach(item => {
        if (this.isScrolledIntoView(item)) {
          let id = parseInt(item.getAttribute('data-id'))
          if (this.activeNavIndex !== id) {
            this.scrollLeft(id)
          }
          this.activeNavIndex = id
        }
      })
    },
  },
  mounted() {
    if (this.isMobile) {
      setTimeout(() => {
        window.addEventListener('scroll', this.scrollPage)
      }, 100)
    }

    let anchor = this.$route.hash.substring(1)
    if (anchor) {
      setTimeout(() => {
        this.$root.scrollToBlock('.js-' + anchor)
      }, 1500)
    }
  },
  beforeRouteEnter(to, from, next) {
    let url = process.env.NODE_ENV !== 'production' ? 'lk/servicesPage.json' : 'lk/services'
    Vue.http.get(url, { params: to.query }).then(
      data => {
        next(vm => vm.setData(data.data))
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener('scroll', this.scrollPage)
    next()
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/pages/lk/services/index.vue